<section class="due-survey-dialog">
    <div class="uscb-layout-row uscb-bg-primary uscb-color-white">
        <h2 class="vcenter uscb-flex uscb-padding-TB-0 uscb-padding-LR-8 uscb-title-3 uscb-color-white">
            {{safeDialogData.title}} {{safeDialogData.date | date}}</h2>
        <span class="vcenter">
            <mat-icon (click)="close(true)" (keyup.enter)="close(true)" tabindex="0" aria-hidden="false">close</mat-icon>
        </span>
    </div>

    <mat-dialog-content>
        <div class="my-dialog-content uscb-layout-column uscb-layout-align-center-center">
            <div class="survey-card-grid uscb-layout-row scb-flex-row uscb-padding-0" tabindex="0" [attr.aria-label]="safeDialogData.surveys ? safeDialogData.surveys.length + ' surveys are due on specified date' : '0 surveys are due on specified date'">
                @for (survey of safeDialogData.surveys; track survey.surveyId; let i = $index) {
                <div class="uscb-padding-0">
                    <app-grid-view-instance card-id="{{'card-' + i}}" [survey]="survey" [active]="safeDialogData.active"></app-grid-view-instance>
                </div>
                }
            </div>
        </div>
    </mat-dialog-content>
</section>
